import styled from 'styled-components';

export const Backdrop = styled.div<{ $open: boolean }>`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  visibility: ${({ $open }) => ($open ? 'visible' : 'hidden')};
  transition: opacity 0.25s ease, visibility 0.25s ease;
  z-index: 1200;
`;

export const Panel = styled.aside<{ $open: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 460px;
  max-width: 92vw;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.12);
  transform: translateX(${({ $open }) => ($open ? '0' : '100%')});
  transition: transform 0.28s ease;
  z-index: 1201;
  display: flex;
  flex-direction: column;
  padding: 24px;
  overflow-y: auto;
`;

export const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  h3 {
    font-size: 20px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.heading};
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 22px;
  color: ${({ theme }) => theme.colors.muted};
  display: flex;
`;

export const Intro = styled.p`
  margin: 16px 0 20px;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.muted};
`;

export const Block = styled.div<{ $destaque?: boolean }>`
  border: 1px solid ${({ theme }) => theme.colors.gray[300]};
  border-radius: 12px;
  padding: 4px 16px;
  margin-bottom: 12px;

  background: ${({ theme, $destaque }) =>
    $destaque ? theme.colors.primary[80] : theme.colors.white};
  border-color: ${({ theme, $destaque }) =>
    $destaque ? theme.colors.primary[60] : theme.colors.gray[300]};
`;

export const BlockHeader = styled.button<{ $open: boolean }>`
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;
  padding: 14px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  .titulo {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 15px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.heading};

    svg {
      font-size: 20px;
      color: ${({ theme }) => theme.colors.orange.primary};
    }
  }

  .chevron {
    flex-shrink: 0;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.muted};
    transform: rotate(${({ $open }) => ($open ? '180deg' : '0')});
    transition: transform 0.2s ease;
  }
`;

export const BlockBody = styled.div`
  padding: 0 0 16px 30px;

  p {
    font-size: 13px;
    line-height: 1.5;
    color: ${({ theme }) => theme.colors.muted};
  }
`;

export const Item = styled.div`
  display: flex;
  gap: 10px;
  padding: 8px 0;

  svg {
    flex-shrink: 0;
    font-size: 18px;
    margin-top: 2px;
    color: ${({ theme }) => theme.colors.orange.primary};
  }

  div {
    display: flex;
    flex-direction: column;
  }

  strong {
    font-size: 13px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.heading};
  }

  span {
    font-size: 13px;
    line-height: 1.4;
    color: ${({ theme }) => theme.colors.muted};
  }
`;

export const Footer = styled.div`
  margin-top: auto;
  padding-top: 20px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.muted};

  a {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: ${({ theme }) => theme.colors.orange.primary};
    font-weight: 600;
    text-decoration: none;
  }
`;
